import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./confirmationFlow.html";
import cx from 'classnames';
import { WireI18n } from '~/modules/stores/i18nStore';
import { images } from '~/modules/utilities/assetUtilities';
class ConfirmationFlow extends LightningElement {
  constructor(...args) {
    super(...args);
    this.title = '';
    this.confirmationTitle = '';
    this.confirmationSubtitle = '';
    this.confirmationDescription = '';
    this.loading = false;
    this.confirming = false;
    this.showListingSummaryCard = false;
    this.confirmationImgSrc = images.tryConfirmationAppy;
    this.headerImgSrc = images.simplifiedTrialsHeader;
  }
  i18nConnectedCallback(i18n) {
    this.labels = i18n.confirmationFlow;
  }
  get headerImgAltText() {
    return this.labels.headerAltText;
  }
  get confirmationImgAltText() {
    return this.labels.confirmationImgAltText;
  }
  get headerClass() {
    return cx('header', this.confirming && 'hidden');
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(ConfirmationFlow, {
  publicProps: {
    title: {
      config: 0
    },
    confirmationTitle: {
      config: 0
    },
    confirmationSubtitle: {
      config: 0
    },
    confirmationDescription: {
      config: 0
    },
    loading: {
      config: 0
    },
    confirming: {
      config: 0
    },
    showListingSummaryCard: {
      config: 0
    }
  },
  wire: {
    i18nConnectedCallback: {
      adapter: WireI18n,
      method: 1,
      config: function ($cmp) {
        return {};
      }
    }
  },
  fields: ["confirmationImgSrc", "headerImgSrc"]
});
const __lwc_component_class_internal = _registerComponent(ConfirmationFlow, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;